import { createContext, useContext } from 'react';

/**
 * How many `PageBody`s enclose this point: 0 outside any page, 1 inside the
 * page itself, 2+ inside a page shown within another page (the admin viewer
 * renders whole role dashboards). Only the outermost page owns the `h1` and
 * the breadcrumb trail.
 */
export const PageDepthContext = createContext(0);

export function usePageDepth(): number {
  return useContext(PageDepthContext);
}
